export default {
  "name": "NCCarousel",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCCarousel",
  "label": "轮播图",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "组件标识",
        "type": "string"
      },
      "containerClass": {
        "title": "Carousel容器样式",
        "description": "Carousel容器样式",
        "type": "string"
      },
      "wrapperClass": {
        "title": "Carousel父元素样式",
        "description": "Carousel父元素样式",
        "type": "string"
      },
      "slideClass": {
        "title": "Carousel单个元素样式",
        "description": "Carousel单个元素样式",
        "type": "string"
      },
      "noSwiping": {
        "title": "禁用滑动",
        "description": "禁用滑动",
        "type": "boolean"
      },
      "activeSlideKey": {
        "title": "激活态slide",
        "description": "激活态slide",
        "type": "number"
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}